declare global {
  interface Window {
    dataLayer: Record<string, unknown>[];
  }
}

export interface DataLayerInfo {
  crewCd: string;
  agencyCd: string;
  employeeNumber: string;
}

/**
 * Pushes crew, agency and employee information to the dataLayer.
 * Useful for tracking data with Gooogle Tag Manager(GTM).
 *
 * @param {DataLayerInfo} - Object containing crewCd, agencyCd, employeeNumber.
 */

export const pushDataToLayer = ({ crewCd, agencyCd, employeeNumber }: DataLayerInfo): void => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    crewCd,
    agencyCd,
    employeeNumber,
  });
};

/**
 * Formats the input data by adding labels to the `crewCd`, `agencyCd`, `employeeNumber`
 * values, then pushes the formatted data to the global `dataLayer`.
 *
 * @param {DataLayerInfo} dataLayerInfo - Object containing crewCd, agencyCd, employeeNumber.
 */
export const initDataLayer = (dataLayerInfo: DataLayerInfo): void => {
  const crewCd = `${dataLayerInfo.crewCd || ''}`;
  const agencyCd = `${dataLayerInfo.agencyCd || ''}`;
  const employeeNumber = `${dataLayerInfo.employeeNumber || ''}`;
  pushDataToLayer({ crewCd, agencyCd, employeeNumber });
};
